module.exports = __webpack_public_path__ + "img/tantan-propa.477b1bb8.png";